import styled, { css } from 'styled-components';
import { Typography } from '../../Typography';

export const TabItem = styled.li<{ isSelected: boolean; disabled: boolean }>`
  flex: 1 1 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background-color: ${({ theme }) => theme.colors.background.tertiary};
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.colors.background.primary};
      span {
        color: ${({ theme }) => theme.colors.text.secondary};
      }
    `}

  &:hover {
    ${({ $isSelected, disabled }) =>
      !$isSelected &&
      !disabled &&
      css`
        span {
          color: ${({ theme }) => theme.colors.systemColors.blue};
        }
      `}
  }

  &:first-of-type {
    border-top-left-radius: 14px;
    border-bottom-left-radius: 14px;
    border-right: 1px solid ${({ theme }) => theme.colors.border.primary};
  }

  &:last-of-type {
    border-top-right-radius: 14px;
    border-bottom-right-radius: 14px;
    border-left: 1px solid ${({ theme }) => theme.colors.border.primary};
  }
`;

export const TabText = styled(Typography)<{ $isSelected: boolean }>`
  ${({ $isSelected }) =>
    $isSelected &&
    css`
      color: ${({ theme }) => theme.colors.systemColors.blue};
    `}
`;
